import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { map, Observable } from 'rxjs';
import { ApiRoutes } from '../constants/api-routes.constants';
import { UserRoleEnum } from '../enums/user.enums';
import { User, UserResponseDTO } from '../types/user.types';
import { createEndpointUrl } from '../utilities/pure-functions';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public http = inject(HttpClient);

  public getCookieValue(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  getUserRoleFromAccessTokenCookie(): UserRoleEnum | null {
    const cookies = document.cookie.split('; ');
    const accessTokenCookie = cookies.find((cookie) => cookie.startsWith('access='));

    if (!accessTokenCookie) return null;

    const accessToken = accessTokenCookie.split('=')[1];
    const decodedToken: any = jwtDecode(accessToken);

    return decodedToken.role as UserRoleEnum;
  }

  public login(email: string, password: string): Observable<void> {
    const url = createEndpointUrl(ApiRoutes.loginUser);
    return this.http.post<void>(url, { email, password });
  }

  public logout(): Observable<null> {
    const url = createEndpointUrl(ApiRoutes.logoutUser);
    return this.http.post<null>(url, null, { withCredentials: true });
  }

  public refresh(): Observable<null> {
    const url = createEndpointUrl(ApiRoutes.refreshToken);
    return this.http.post<null>(url, null, {
      withCredentials: true,
    });
  }

  public me(): Observable<User> {
    const url = createEndpointUrl(ApiRoutes.getUserMe);
    return this.http
      .get<UserResponseDTO>(url, { headers: { addAuthHeader: 'true' } })
      .pipe(map((response) => response.payload));
  }
}
